

import EyeIcon from "./Icons/EyeIcon.vue";
import EyeOffIcon from "./Icons/EyeOffIcon.vue";
import ShareIcon from "./Icons/ShareIcon.vue";
import PlusCircleIcon from "./Icons/PlusCircleIcon.vue";
import MinusCircleIcon from "./Icons/MinusCircleIcon.vue";
import MessageChatSquareIcon from "./Icons/MessageChatSquareIcon.vue";
import FolderPlusIcon from "./Icons/FolderPlusIcon";
import ChevronLeftIcon from "./Icons/ChevronLeftIcon.vue";
import ChevronRightIcon from "./Icons/ChevronRightIcon.vue";
import ScreenUtils from './Mixins/ScreenUtils.js';
import BookIcon from "./Icons/BookIcon.vue";
import InfoCircleIcon from "./Icons/InfoCircleIcon.vue";
import SearchMediumIcon from "./Icons/SearchMediumIcon.vue";
import ZoomOutIcon from "./Icons/ZoomOutIcon.vue";
import ZoomInIcon from "./Icons/ZoomInIcon.vue";
import MenuButton from "./MenuButton.vue";
import FileDownloadIcon from "./Icons/FileDownloadIcon.vue";
import PencilLineIcon from "./Icons/PencilLineIcon.vue";
import {ObserveVisibility} from 'vue-observe-visibility'

export default {
    name: "PageNavigator",
    directives: {
        ObserveVisibility
    },
    components: {
        MenuButton,
        ShareIcon,
        MinusCircleIcon,
        PlusCircleIcon,
        MessageChatSquareIcon,
        BookIcon,
        EyeIcon,
        FolderPlusIcon,
        InfoCircleIcon,
        SearchMediumIcon,
        ZoomOutIcon,
        ZoomInIcon,
        FileDownloadIcon,
        PencilLineIcon,
        ChevronLeftIcon,
        ChevronRightIcon,
        EyeOffIcon
    },
    props: {
        isReadMode: Boolean,
        isText: Boolean,
        isDownloadable: Boolean,
        isAllRegsOpen: Boolean,
        isNavigatorAtTheTop: Boolean,
        hasAnyRegulations: Boolean,
    },
    mixins: [ScreenUtils],
    inject: ['fvAPI_SearchInFile', 'user', 'fvAPI_DownloadFile', 'fvAPI_DownloadFileLoading', 'isLogged', 'toast'],
    data() {
        return {
            showLeft: false,
            showRight: false,
        }
    },
    methods: {
        scrollToRight() {
            const scrollAmount = this.$refs.scrollContainer.scrollLeft + Math.ceil(this.$refs.scrollContainer.clientWidth / 2)
            this.$refs.scrollContainer.scrollTo({left: scrollAmount, behavior: 'smooth'})
        },
        scrollToLeft() {
            const scrollAmount = this.$refs.scrollContainer.scrollLeft - Math.ceil(this.$refs.scrollContainer.clientWidth / 2)
            this.$refs.scrollContainer.scrollTo({left: scrollAmount, behavior: 'smooth'})
        }
    }
}
